import { t } from "@travily/i18n";
import type CelebrationsRow from "@travily/types/models/CelebrationsRow";
import { EmptyState } from "@ui/components/EmptyState";
import { Heading } from "@ui/components/Heading";
import { Icon } from "@ui/components/Icon";
import { Illustration } from "@ui/components/Illustration";
import { PromptButton } from "@ui/components/PromptButton";
import { CelebrationCard } from "./CelebrationCard";

export interface CelebrationsProps {
  celebrations: CelebrationsRow[];
  onAddCelebration?: () => void;
  ownerDisplayName: string;
}

export function Celebrations({ celebrations, onAddCelebration, ownerDisplayName }: CelebrationsProps) {
  return (
    <div className="mt-8 flex w-full flex-col gap-5 text-left lg:mt-12 lg:gap-8">
      <Heading.Root divider="responsive">
        <Heading.Title>{t("components.views.shared.celebrations.title")}</Heading.Title>
      </Heading.Root>
      {onAddCelebration && (
        <PromptButton
          description={t("components.views.shared.celebrations.add_hint")}
          icon={<Icon name="confetti" type="sticker" />}
          onPress={onAddCelebration}
        >
          {t("components.views.shared.celebrations.add")}
        </PromptButton>
      )}
      {celebrations.length > 0 ? (
        <div className="flex flex-col gap-5 lg:gap-8">
          {celebrations.map((celebration) => (
            <CelebrationCard celebration={celebration} key={celebration.id} />
          ))}
        </div>
      ) : (
        <EmptyState
          description={
            onAddCelebration
              ? t("components.views.shared.celebrations.empty_description_owner", { name: ownerDisplayName })
              : t("components.views.shared.celebrations.empty_description_other")
          }
          illustration={<Illustration name="celebrations" />}
          title={t("components.views.shared.celebrations.empty_title")}
        />
      )}
    </div>
  );
}
